<script>
  import GanttHelper from './GanttHelper.js';
  import { translate } from '../../i18n/i18next.js';
  import { onMount } from 'svelte';

  export let GanttStore

  const CalculateStartX = (itemStart) => Math.min(100, 100 * GanttHelper._gantHelper_scale(AdjustStamp(itemStart).getTime(), $CurrentDisplayedEndDate.getTime(), $CurrentDisplayedStartDate.getTime()));
  const AdjustStamp = (stamp) => GanttHelper._gantHelper_adjustDateWithinADay(stamp, $StartDayDisplayTime, $EndDayDisplayTime, $DayStartTime);

  $: HideInvalidDate = (s) => s === "Invalid Date" ? "" : s;

  const {
    InternalLowerSubSplits,
    StartDayDisplayTime,
    EndDayDisplayTime,
    CurrentDisplayedStartDate,
    CurrentDisplayedEndDate,
    GanttChartType,
    DayStartTime,
    GetAdjustedDateInclDaysOff,
    OtherDemarcationTimes
  } = GanttStore;

  let currentDate = new Date();

  onMount(() => {
    currentDate = new Date();
		const nowInterval = setInterval(() => {
			currentDate = new Date();
		}, 10000);

		return () => clearInterval(nowInterval);
	});

</script>

<div id="gantt_chartarea_footerpadding">
  <svg id="gantt_chartarea_chartfooter">
    <!-- Now date orange marker -->
    <marker
      id="nowMarker"
      viewBox="0 0 12 12"
      refX="6"
      refY="6"
      markerWidth="12"
      markerHeight="12"
      markerUnits="userSpaceOnUse"
      orient="auto">
      <polygon points="0 6,6 12,12 6,6 0" style=" fill: #FF9F00"/>
    </marker>

    {#each $InternalLowerSubSplits.toSorted() as tp}
      <rect
        x="{CalculateStartX(tp)}%"
        y="5%"
        width="35px"
        height="35%"
        fill="white"
      />
      <line
        x1="{CalculateStartX(tp)}%"
        y1="0%"
        x2="{CalculateStartX(tp)}%"
        y2="30%"
        fill="#00000011"
        style="stroke: #888888; stroke-opacity: 1 "
      />
      <text
        x="{CalculateStartX(tp) + 0.2}%"
        y="35%"
        font-size="12px"
        fill="#888888"
      >
        {HideInvalidDate(tp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }))}
      </text>

    {/each}

    <line
      x1="{CalculateStartX($GetAdjustedDateInclDaysOff(currentDate))}%"
      y1="0%"
      x2="{CalculateStartX($GetAdjustedDateInclDaysOff(currentDate))}%"
      y2="0%"
      style="stroke: #FF9F00; stroke-width: 2px"
      marker-end="url(#nowMarker)"
    />

  </svg>

  <span id="gantt_chartarea_chartfooter_ddt">
    {translate("asprova.terms.visibleTimesOfDay")}：{$StartDayDisplayTime} - {$EndDayDisplayTime}
  </span>

</div>


<style>
  div#gantt_chartarea_footerpadding {
    height: 40px;
    width: 100%;
    background-color: white;
    border-top: 2px solid #888888;
    position: relative;
  }

  svg#gantt_chartarea_chartfooter {
    width: 100%;
    height: 100%;
    float: left;
  }

  span#gantt_chartarea_chartfooter_ddt {
    color: #888888;
    bottom: 6px;
    right: 0;
    font-size: 12px;
    float: right;
    margin-right: 10px;
    position: absolute;
  }

</style>
